
























import { Component, Vue } from "vue-property-decorator";
import { Console, Events } from "@/common/global.ts";

import BaseView from "@/common/base-view.ts";

@Component
export default class FooterBasic extends BaseView {

}
